<lib-row-with-two-columns
  [column1FxFlex]="flexLeft"
  [column2FxFlex]="flexRight"
  [column1FxLayoutAlign]="'center start'"
  [column2FxLayoutAlign]="'center start'"
>
  <div col-1 class="full-width">
    <div>
      <span>{{ title | translate }}:</span>
      <span class="highlight-value" [class.activated]="isOn">
        {{ (isOn ? textOn : textOff) | translate }}
      </span>
    </div>
    <div *ngIf="description" class="description">
      {{ description | translate }}
    </div>
  </div>
  <div col-2 class="full-width">
    <ng-content></ng-content>
  </div>
</lib-row-with-two-columns>
